<template>
    <svg height="16" viewBox="0 0 40 16" width="40" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke="#fff" stroke-width="2"><g transform="translate(33 1.5)"><path d="m0 0c0 3.58985087 2.91014913 6.5 6.5 6.5"/><path d="m6.5 6.5c-3.58985087 0-6.5 2.91014913-6.5 6.5"/></g><path d="m38.5 8h-36.5" stroke-linecap="square"/></g></svg>
</template>
